import styled from 'styled-components';

export const MOBILE_BREAKPOINT = 767;
export const TABLET_BREAKPOINT = 1023;
export const SMALL_DESKTOP_BREAKPOINT = 1231;

export const Flex = styled.div`
    display:  ${props => props?.display || 'flex'};
    width: ${props => props?.width || '100%'};
    max-width: ${props => props?.maxWidth};
    justify-content: ${props => props?.justifyContent};
    align-items: ${props => props?.alignItems};
    align-content: ${props => props?.alignContent};
    margin: ${props => props?.margin};
    filter: ${props => props?.filter};
    gap: ${props => props?.gap};
    flex-direction: ${props => props?.flexDirection};
    padding: ${props => props?.padding};
    padding-bottom: ${props => props.paddingBottom};
    padding-top: ${props => props.paddingTop};
    padding-left: ${props => props.paddingLeft};
    padding-right: ${props => props.paddingRight};
    border-radius: ${props => props?.borderRadius};
    border: ${props => props?.border};
    border-top: ${props => props?.borderTop};
    border-bottom: ${props => props.borderBottom};
    border-left: ${props => props?.borderLeft}
    border-right: ${props => props.borderRight};
    background: ${props => props?.background};
    flex-wrap: ${props => props?.flexWrap};
    flex: ${props => props?.flex};
    color: ${props => props?.color};
    height: ${props => props?.height};
    max-height: ${props => props?.maxHeight};
    grid-area: ${props => props.gridArea};
    margin-left: ${props => props.marginLeft};
    margin-right: ${props => props.marginRight};
    margin-top: ${props => props.marginTop};
    margin-bottom: ${props => props.marginBottom};
    place-self: ${props => props.placeSelf};
    text-align: ${props => props.textAlign};
    background-color: ${props => props.backgroundcolor};
    overflow: ${props => props?.overflow};
    position: ${props => props?.position};
    top: ${props => props?.top};
    bottom: ${props => props?.bottom};
    left: ${props => props?.left};
    right: ${props => props?.right};
    z-index: ${props => props?.zIndex};
    box-sizing: ${props => props?.boxSizing || 'border-box'};
    box-shadow: ${props => props?.boxShadow};
  `;

export const Block = styled.div`
  display: ${props => props?.display || 'block'};
  width: ${props => props?.width || '100%'};
  max-width: ${props => props?.maxWidth};
  margin: ${props => props?.margin};
  padding: ${props => props?.padding};
  padding-bottom: ${props => props.paddingBottom};
  padding-top: ${props => props.paddingTop};
  padding-left: ${props => props.paddingLeft};
  padding-right: ${props => props.paddingRight};
  border-radius: ${props => props?.borderRadius};
  border: ${props => props?.border};
  border-top: ${props => props?.borderTop};
  border-bottom: ${props => props.borderBottom};
  border-left: ${props => props?.borderLeft}
  border-right: ${props => props.borderRight};
  background: ${props => props?.background};
  color: ${props => props?.color};
  height: ${props => props?.height};
  max-height: ${props => props?.maxHeight};
  grid-area: ${props => props.gridArea};
  margin-left: ${props => props.marginLeft};
  margin-right: ${props => props.marginRight};
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
  place-self: ${props => props.placeSelf};
  text-align: ${props => props.textAlign};
  background-color: ${props => props.backgroundcolor};
  overflow: ${props => props?.overflow};
  position: ${props => props?.position};
  top: ${props => props?.top};
  bottom: ${props => props?.bottom};
  left: ${props => props?.left};
  right: ${props => props?.right};
  z-index: ${props => props?.zIndex};
  box-sizing: ${props => props?.boxSizing || 'border-box'};
`;

export const GridWrapper = styled.div`
    width: 100%;
    max-width: ${props => props.maxWidth};
    height: ${props => props.height};
    display: ${props => props.display || 'grid'};
    column-gap: ${props => props.columnGap};
    gap: ${props => props.gap};
    grid-template-columns: ${props => props.gridTemplateColumns};
    grid-template-rows: ${props => props.gridTemplateRows};
    grid-template-areas: ${props => props.gridTemplateAreas};
    grid-column: ${props => props.gridColumn};
    grid-row: ${props => props.gridRow};
    grid-row-gap: ${props => props.gridRowGap};
    grid-column-gap: ${props => props.gridColumnGap};
    justify-content: ${props => props.justifyContent};
    justify-items: ${props => props.justifyItems};
    align-items: ${props => props.alignItems};
    margin: ${props => props.margin};
    margin-left: ${props => props.marginHoriz};
    margin-right: ${props => props.marginHoriz};
    margin-top: ${props => props.marginTop};
    margin-bottom: ${props => props.marginBottom};
    color: ${props => props.color};
    background-color: ${props => props.backgroundcolor};
    padding: ${props => props.padding};
    padding-left: ${props => props.paddingLeft};
    padding-right: ${props => props.paddingRight};
    padding-bottom: ${props => props.paddingBottom};
    padding-top: ${props => props.paddingTop};
    border: ${props => props?.border};
    border-top: ${props => props?.borderTop};
    border-bottom: ${props => props?.borderBottom};
    border-left: ${props => props?.borderLeft};
    border-right: ${props => props?.borderRight};
  `;

export const TileWrapper = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  border: ${props => props.border};
  border-top: ${props => props?.borderTop};
  border-bottom: ${props => props?.borderBottom};
  border-left: ${props => props?.borderLeft};
  border-right: ${props => props?.borderRight};
  max-width: ${props => props.maxWidth};
  padding: ${props => props.padding};
  padding-top: ${props => props.paddingTop};
  background-color: ${props => props.backgroundcolor};
  margin: ${props => props?.margin};
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
  border-radius: ${props => props.borderRadius};
  display: flex;
  gap: ${props => props.gap};
  flex-direction: column;
  justify-content: ${props => props.justifyContent};
  pointer: ${props => props.pointer};
  max-height: ${props => props.maxHeight};
`;

export const ContainerWrapper = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  max-width: ${props => props.maxWidth};
  padding: ${props => props.padding};
  margin: ${props => props.margin};
  background-color: ${props => props.backgroundcolor};
  box-sizing: border-box;
`;

export const ContentBackground = styled.div`
  background-color: ${props => props.backgroundcolor || "#F8F3E9"};
`;

export const StickyHeader = styled.div`
  position: sticky;
  top:0;
  background-color: #fff;
  z-index: 999;
`

export const FixedFooter = styled.footer`
  position: sticky;
  left: 0;
  bottom: ${props => props?.bottom || "0"};
  width: 100%;
  background: #fff;
  z-index: 10;
  box-shadow: ${props => props?.boxShadow || "0 -2px 8px rgba(0,0,0,0.05)"};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => props?.padding || "16px"};
  
`;

export const ImageWrapper = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  max-width: ${props => props.maxWidth};
  max-height: ${props => props.maxHeight};
  min-width: ${props => props.minWidth};
  min-height: ${props => props.minHeight};
  overflow: ${props => props.overflow};
  display: flex;
  justify-content: ${props => props.justifyContent};
  border: ${props => props.border};
  border-radius: ${props => props.borderRadius};
  align-items: ${props => props.alignItems};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  background-color: ${props => props.backgroundcolor};
  position: ${props => props.position};
  top: ${props => props.top};
  left: ${props => props.left};
  right: ${props => props.right};
  bottom: ${props => props.bottom};
`;

export const LoaderContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 44px;
  position: relative;
  text-align: center;
  width: 100%;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: ${props => props.borderRadius};
  object-fit: cover;
  src: ${props => props.src};
  alt: ${props => props.alt};
`;
